import { ReactElement } from 'react';
import Label from '../../../../../../common/label/label';
import cn from '../../../../../../utils/classnames';
import MaterialSchoolLabel from '../../components/material-school-label/material-school-label';
import { useCardContext } from '../../contexts/favorites-material-card-context';
import useCard from '../../hooks/use-card';
import { FavoritesMaterialCardVariationProps } from '../../types';
import Footer from './components/footer/footer';
import LeftAside from './components/left-aside/left-aside';
import RightAside from './components/right-aside/right-aside';
import './mobile-card.scss';

const MobileCard = (props: FavoritesMaterialCardVariationProps): ReactElement => {
    const { item, index, internalPath, hasSchoolLabel, banner, voteButton, ...footerProps } = props;

    const card = useCard({
        item,
        internalPath,
        screen: 'mobile',
        className: cn({ 'with-school-label': hasSchoolLabel })
    });
    const { cardRef } = useCardContext();

    return (
        <div ref={cardRef} className={card.classNames} data-testid={card.testId}>
            {card.label && <Label item={item} />}

            {hasSchoolLabel && <MaterialSchoolLabel />}

            <LeftAside item={item} index={index} internalPath={internalPath} />

            <RightAside item={item} index={index} internalPath={internalPath} />

            <Footer item={item} index={index} internalPath={internalPath} {...footerProps} />

            {banner}

            {voteButton}
        </div>
    );
};

export default MobileCard;
